import { Link, useLocation } from "react-router-dom";

import { tabCurrent, type ViewTab } from "../navigation";

export interface ViewTabsProps {
  tabs: readonly ViewTab[];
  /** A number to show after a tab's name, by the tab's id. Zero or missing shows nothing. */
  badges?: Readonly<Record<string, number>>;
}

/**
 * The tabs of the bar. They are links: a tab is marked "page" on the screen it opens and "true" on another screen under it (an
 * item page is under Items). A number after a tab's name is also said in words for a screen reader.
 */
export function ViewTabs({ tabs, badges = {} }: ViewTabsProps) {
  const { pathname } = useLocation();
  return (
    <ul className="frame__tabs">
      {tabs.map((tab) => {
        const count = badges[tab.id] ?? 0;
        return (
          <li key={tab.id}>
            <Link className="frame__tab" to={tab.to} aria-current={tabCurrent(tab, pathname)}>
              <span className="frame__tab-label">{tab.label}</span>
              {count > 0 && (
                <>
                  <span className="frame__badge" aria-hidden="true">
                    {count}
                  </span>
                  <span className="sr-only">, {count} waiting</span>
                </>
              )}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
